import { render, staticRenderFns } from "./visits-institutions-chart.vue?vue&type=template&id=1d8ae003&scoped=true&lang=pug&"
import script from "./visits-institutions-chart.vue?vue&type=script&lang=ts&"
export * from "./visits-institutions-chart.vue?vue&type=script&lang=ts&"
import style0 from "./visits-institutions-chart.vue?vue&type=style&index=0&id=1d8ae003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8ae003",
  null
  
)

export default component.exports